import { Theme } from '@insights-gaming/theme';

function makeGameDataAssetResourceMapFn(
  gameVersion = 'latest',
  region = 'global',
  language = 'default',
) {
  const cdragon = `https://raw.communitydragon.org/${gameVersion}/plugins/rcp-be-lol-game-data/${region}/${language}/`;
  return function getGameDataAssetPath(assetPath: string) {
    return cdragon + assetPath.replace('/lol-game-data/assets/', '').toLowerCase();
  };
}

export function getUserColor(theme: Theme, isUserTeam: boolean) {
  return isUserTeam ? theme.palette.overwatch.blueTeam : theme.palette.overwatch.redTeam;
}

export function buildLeagueProxyUrl(endpoint: string, region: string, matchId: number): string {
  const newMatchId = `${region}_${matchId}`; // For Riot API Match v5
  return `${endpoint}/external/riot/proxy?game=lol&matchId=${newMatchId}&region=${region}`;
}

export function getChampionIconSrc(championId: number, gameVersion?: string) {
  return makeGameDataAssetResourceMapFn(gameVersion)(`v1/champion-icons/${championId}.png`);
}

export function getIconAsset(path: string, gameVersion?: string) {
  return makeGameDataAssetResourceMapFn(gameVersion)(path);
}

// gameDuration is in seconds
export function getGameDurationInMin(gameDuration: number) {
  return gameDuration / 60;
}

export function extractGameVersion(gameVersion: string) {
  return gameVersion.split('.').slice(0, 2).join('.');
}

export function getRegion(region: string): string | void {
  switch (region) {
    case 'BR': return 'BR1';
    case 'EUNE': return 'EUN1';
    case 'EUW': return 'EUW1';
    case 'LAN': return 'LA1';
    case 'LAS': return 'LA2';
    case 'NA': return 'NA1';
    case 'OCE': return 'OC1';
    case 'TR': return 'TR1';
    case 'KR': return 'KR';
    case 'JP': return 'JP1';
    case 'RU': return 'RU';
  }
}
